import React from 'react';
import CustomerService from './CustomerService';
import Footer from '../footer/footer';

const CustomerServicePage = () => (
  <>
    <CustomerService />
    <Footer />
  </>
);

export default CustomerServicePage;
